import { workSheetConstants } from '../../_constants';

const initialState = { shareWorksheetLoading: true, data: '', error: false };

export function shareWorksheetReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_SHARE_WORKSHEET:
            return {
                shareWorksheetLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_SHARE_WORKSHEET:
            return {
                shareWorksheetLoading: false,
                data: action.shareWorksheet,
                error: false
            };
        case workSheetConstants.SHARE_WORKSHEET_ERROR:
            return {
                shareWorksheetLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/shareWorkSheet.reducer.js